
import { Component, Prop, Vue } from "vue-property-decorator";
import { rulesForms } from "@/core/RulesForm";
import { Action } from "@/core/CommonDefinition";
import ContactEtablissement from "@/core/ContactEtablissement";
import MotDePasse from "@/components/authentification/MotDePasse.vue";

@Component({
  components: { MotDePasse }
})
export default class Contact extends Vue {
  @Prop() contact!: ContactEtablissement;
  @Prop() action!: Action;
  @Prop() isDisableForm!: boolean;
  Action: any = Action;
  rulesForms: any = rulesForms;
  emailConfirmation: string = "";
  ancienMail: string = "";

  constructor() {
    super();
    this.ancienMail = this.contact.mail;
  }

  get rulesMailConfirmation() {
    return () =>
      this.emailConfirmation === this.contact.mail ||
      this.emailConfirmation === "" ||
      "Le mail de confirmation n'est pas valide";
  }

  gotoDonneesPersonnellesInNewPage(): void {
    const route = this.$router.resolve({ path: "/donneespersonnelles" });
    window.open(route.href);
  }

  checkConfirmationMail(): void {
    if (this.emailConfirmation != "") {
      (this.$refs.mail as Vue & { validate: () => boolean }).validate();
    }
  }

  validate(): boolean {
    const isFormValide = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();

    let isMotDePasseValide = true;
    if (this.$refs.motdepasse) {
      isMotDePasseValide = (this.$refs.motdepasse as Vue & {
        validate: () => boolean;
      }).validate();
    }

    let isMailValide = true;
    if (
      this.action == Action.CREATION ||
      this.ancienMail != this.contact.mail
    ) {
      isMailValide = (this.$refs.mail as Vue & {
        validate: () => boolean;
      }).validate();
    }

    return isFormValide && isMotDePasseValide && isMailValide;
  }

  clear(): void {
    if (this.$refs.motdepasse) {
      (this.$refs.motdepasse as MotDePasse).clear();
    }
    (this.$refs.form as HTMLFormElement).resetValidation();
    (this.$refs.mail as HTMLFormElement).resetValidation();
    this.contact.reset();
  }

  updateMotDePasse(value: string) {
    this.contact.motDePasse = value;
  }

  pastePhone(evt) {
    this.contact.telephone = evt.clipboardData
      .getData("text")
      .replaceAll(" ", "")
      .replaceAll(".", "");
  }
}
